import { Navigate } from "@tanstack/react-router";
import { ROUTES } from "@/constants/routeConstants";
import { useAuthStore } from "@/store/auth";

export const RequireSignedOut = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const user = useAuthStore((s) => s.user);

  if (user) {
    return <Navigate to={ROUTES.ANALYTICS} replace={true} />;
  }

  return children;
};
